<template>
  <div>
    <div class="card card-info">
      <div class="card-header with-border">
        <h3 class="card-title">
          Manage
        </h3>
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <div class="card-body" style="padding-left: 1%; padding-right: 1%; padding-top: 1%">
        <div class="row" style="margin-top: 10px">
          <div class="col-md-4">
            Enter Student Form No.
            <div class="input-group input-group-sm">
              <input type="text" class="form-control" v-mask="'##########'" v-model="formno">
              <span class="input-group-append">
                <button class="btn btn-info btn-flat" type="button" v-on:click="search()">Search</button>
              </span>
            </div>
          </div>
          <div class="col-md-12" v-if="st">
            <hr />
            <div class="row">
              <div class="col-md-10 col-sm-6">
                <div class="row">
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label>Form No</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.FormNo">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom01">Applicant Name</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.Name">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom01">Father Name</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.FathersName">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom02">Applicant Mobile</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.MobileNo">
                  </div>
                  <div class="col-md-4 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom02">Applicant CNIC</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.CNIC">
                  </div>

                </div>
                <div class="row">
                  <div class="col-md-5">
                    Existing Program
                    <input class="form-control" disabled v-model="st.ExistingProgram" />
                  </div>
                  <div class="col-md-5">
                    Transfer To Program
                    <select class="form-control" v-model="st.NewProspectChoicesID">
                      <option v-for="item in programs.filter((x) => {return x.NewProspectChoicesID != st.PreProspectChoicesID})" v-bind:value="item.NewProspectChoicesID">{{item.Name}}</option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    Date
                    <input class="form-control" type="date" v-model="st.Date" />
                  </div>
                  <div class="col-md-12">
                    Remarks
                    <input class="form-control" v-model="st.Remarks" />
                  </div>
                </div>
              </div>
              <div class="col-md-2 col-sm-4 col-xga-6">
                <img v-bind:src="st.Image" alt="Student Image" style="height: 110px !important" class="img-thumbnail" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="card-footer" style="text-align: right">
        <button type="button" v-on:click="printAdmissionForm()" class="btn btn-primary">View Admission Form</button>
        <button type="button" v-on:click="checkProgramTransferFeeDifference()" class="btn btn-success">Save Changes</button>
        <button type="button" v-on:click="cancel()" class="btn btn-danger">Cancel</button>
      </div>
    </div>

    <div id="myModal" class="modal fade" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-info"> 
            <h4 class="modal-title">Fee Difference</h4>
          </div>
          <div class="modal-body">
            <table class="table table-bordered table-sm">
              <thead class="bg-info">
                <tr>
                  <th width="65">Fee Head</th>
                  <th width="35">Difference</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in difference">
                  <td>{{item.Name}}</td>
                  <td align="right">{{item.Fee.toLocaleString()}}</td>
                </tr>
              </tbody>

              <tfoot>
                <tr>
                  <th>Total Difference</th>
                  <td align="right"><b>{{totalDifference.toLocaleString()}}</b></td>
                </tr>
              </tfoot>
            </table>

            <div class="row" v-if="totalDifference > 0">
              <div class="col-md-12">
                <div class="form-group"></div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Due Date</label>
                  <input type="date" v-model="st.DueDate" class="form-control" />
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer" v-if="st">
            <button type="button" class="btn btn-success btn-sm" v-if="totalDifference == 0" v-on:click="save()">Save</button>
            <button type="button" class="btn btn-success btn-sm" v-else-if="totalDifference > 0" v-on:click="save()">Generate Fee Differece Challan</button>
            <button type="button" class="btn btn-success btn-sm" v-else-if="totalDifference < 0" v-on:click="save()">Generate Fee Refund Challan</button>
            <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
          </div>
        </div>

      </div>
    </div>


  </div>
</template>
<script>

  const axios = require('axios').default;

  export default ({
     
    data() {
      return {
        formno: '',
          
        record: [],
        st: '',
        fee: [],
        duedate: '2021-11-19',
        programs: [],
        difference: [],
        totalDifference: 0,
      }
    },

    created: function () {
    },

    methods: {
      search: function () {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/loadProspectStudentByFormNo?formNo=' + vm.formno)
          .then(function (pl) {
            if (pl.data.status) {
              vm.st = pl.data.ps;
              vm.programs = pl.data.programs;
            } 
            else {
              toastr.error(pl.data.msg);
              vm.st = '';
            }
            endReq();
          })
      },
       
      checkProgramTransferFeeDifference() {
        var vm = this;
        var check = 0;
        var prog = 0;
        var catID = 0;

        //vm.record.forEach(function (item, ind) {
        //  if (item.Select) {
        //    check = check + 1;
        //    prog = item.ProgramID;
        //    catID = item.AdmissionCategoryID;
        //  }
        //});
        //if (check > 1) {
        //  toastr.error("Please select only one program", "Error!");
        //  return;
        //}
        //if (check == 0) {
        //  toastr.error("Please select one program", "Error!");
        //  return;
        //}
        //if (vm.duedate == '' || vm.duedate == null) {
        //  toastr.error("Due Date is required", "Error!");
        //  return;
        //}

        startReq();
        axios.post('/api/AdmissionApi/checkProgramTransferFeeDifference', {
          ps: vm.st
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              $('#myModal').modal('show');
              vm.difference = res.data.difference;
              vm.totalDifference = res.data.totalDifference;
            }
            else {
              toastr.error(res.data.msg, "Error!");
            }
          })
      },

      save() {
        var vm = this;
        
        startReq();
        axios.post('/api/AdmissionApi/saveProgramTransfer', {
          ps: vm.st
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              if (vm.totalDifference > 0) {
                window.open('../Fee/ProspectStudentChallanPrint', "_blank");
              }
              else if (vm.totalDifference < 0) {
                window.open('../Fee/FeeRefundChallan', "_blank");
              }
              else {
                toastr.success("Saved SuccessFully");
              }
              vm.cancel();
            }
            else {
              toastr.error(res.data.msg, "Error!");
            }
            
          })
      },

      cancel() {
        window.location.reload();
      },

      printAdmissionForm() {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/printAdmissionForm?ID=' + vm.st.ProspectStudentID)
          .then(function (res) {
            endReq();
            window.open(res.data.url, '_blank');
          })
          .catch(function (error) {
            console.log(error);
          })
      },
    }
  })
</script>

<style>
/*  table thead tr th {
    background-color: #605ca8;
    color: white;
  }*/

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/programTransfer.vue